import { defineComponent as l, createBlock as o, openBlock as r, unref as n, mergeProps as m, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const u = /* @__PURE__ */ l({
  name: "IconBackMarketPromiseFilled",
  __name: "IconBackMarketPromiseFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (s, e) => (r(), o(n(p), m(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", { d: "M11.597 2.057a1.458 1.458 0 0 1 .807 0l7.555 2.2h-.003A1.462 1.462 0 0 1 21 5.65v3.838l-.009.454c-.173 4.672-3.018 8.763-8.258 11.857A1.442 1.442 0 0 1 12 22l-.19-.012a1.439 1.439 0 0 1-.543-.188c-5.238-3.096-8.085-7.188-8.258-11.858L3 9.488V5.65a1.46 1.46 0 0 1 .93-1.356l.114-.038 7.553-2.199m3.188 5.237a.26.26 0 0 0-.183.078l-3.45 3.456a.109.109 0 0 0 0 .154l3.526 3.533h2.263a.066.066 0 0 0 .046-.112l-3.49-3.498 3.603-3.61h-2.315m-4.52-.001a.26.26 0 0 0-.183.077l-3.45 3.457a.108.108 0 0 0 0 .153l3.527 3.533h2.263a.066.066 0 0 0 .047-.112L9.054 10.98a.108.108 0 0 1 0-.153l3.527-3.534h-2.315" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
